import React, { useRef } from 'react';
import classNames from 'classnames';
import { PageProps } from 'gatsby';
import AirstageIcon from '@/images/svgs/AirstageCloud.svg';
import websitePoster from '@/images/website-poster.jpg';
import websiteVideo from '@/images/website-video.mp4';

const VideoSection: React.FC<PageProps> = () => {
  const videoEl = useRef(null);
  const videoClasses = classNames(
    'relative w-full flex flex-col items-center justify-start',
    'after:z-0 after:absolute after:bottom-0 after:left-0 after:w-full after:h-full',
    'after:bg-gradient-to-t after:from-black/35 after:to-transparent',
    'bg-video-section bg-no-repeat bg-cover bg-top'
  );

  return (
    <>
      <section className={videoClasses}>
        <div className="wrapper w-full z-10 text-white pt-[6.12rem] flex flex-wrap items-center justify-center">
          <AirstageIcon className="max-w-[42rem] w-full min-w-[200px]" />
        </div>
        <div className="wrapper box-border z-10 w-full my-[5.19rem] ">
          <div className="p-4 sm:p-[4rem] border-[3px] border-white bg-primary/50 rounded-[1.875rem] transition-all duration-300 hover:scale-110">
            <video
              preload="auto"
              controls
              ref={videoEl}
              className="rounded-[1.875rem] overflow-hidden"
              poster={websitePoster}
            >
              <source src={websiteVideo} type="video/mp4" />
              Your browser does not allow <code>video</code>.
            </video>
          </div>
        </div>
      </section>
    </>
  );
};

export default VideoSection;
